import { Box, Grid, Typography } from '@mui/material';
import { ONativeToken, TChainId } from 'modules/api';
import { useBreakpoints } from 'modules/common/hooks/useBreakpoints';
import { getExplorerLink } from 'modules/common/utils/getExplorerLink';
import { getVaultAddress } from 'modules/dashboard/actions/utils/getVaultAddress';
import { useTranslation } from 'modules/i18n';
import { translation } from './translation';
import { BlurredBox } from 'modules/common/components/BlurredBox';
import { useConnection } from 'modules/auth';

function getVaultLink(chainId: TChainId) {
  const vaultContractAddress = getVaultAddress(ONativeToken.LBTC);

  return getExplorerLink(vaultContractAddress, chainId, 'address');
}

const LOCK_AND_MINT_LINK =
  'https://docs.lombard.finance/lbtc-liquid-bitcoin/supported-blockchains';

interface IBlockProps {
  title: string;
  description: string;
}

function Block({ title, description }: IBlockProps) {
  const { isSmDown } = useBreakpoints();

  return (
    <Grid item xs={12} sm={6} md={4}>
      <BlurredBox
        sx={{
          padding: 3,
          borderRadius: 1.2,
          height: '100%',
        }}
      >
        <Typography variant="body1" fontSize={isSmDown ? 16 : 18}>
          {title}
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          mt={1}
          sx={{
            '& a': {
              color: 'text.secondary',
            },
          }}
        >
          {description}
        </Typography>
      </BlurredBox>
    </Grid>
  );
}

export function Information(): JSX.Element {
  const { t, keys } = useTranslation(translation);
  const { chainId } = useConnection();

  const contractLink = chainId ? getVaultLink(chainId): '' ;

  return (
    <Box mt={3}>
      <Typography variant="subtitle1" fontWeight={500}>
        {t(keys.title)}
      </Typography>

      <Grid container spacing={4} justifyContent="center" marginY={-2}>
        <Block
          title={t(keys.security)}
          description={t(keys.securityDescription, { contractLink }, true)}
        />
        <Block
          title={t(keys.ownership)}
          description={t(keys.ownershipDescription)}
        />
        <Block
          title={t(keys.bridging)}
          description={t(
            keys.bridgingDescription,
            { link: LOCK_AND_MINT_LINK },
            true,
          )}
        />
      </Grid>
    </Box>
  );
}
